import DataTable from "@shared/ui/data-table/DataTable";
import SearchTable from "@shared/ui/search-table/SearchTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledCashBoxes } from "./cash-boxes.styled";
import { SEARCH_TABLE_STYLE } from "./cash-boxes.constants";
import { useCashBoxOptions } from "./cash-boxes.data";
import { useCashBoxStructures } from "./useCashBoxStructures";
import { useCashBoxesBrowse } from "./useCashBoxesBrowse";
import { useCashBoxesNavigation } from "./useCashBoxesNavigation";

function CashBoxes() {
  const theme = useTheme();
  const { searchStructure, tableStructure } = useCashBoxStructures();
  const browse = useCashBoxesBrowse();
  const navigation = useCashBoxesNavigation();
  const cashBoxOptions = useCashBoxOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledCashBoxes>
      {searchStructure ? (
        <SearchTable
          structure={searchStructure}
          useForm={browse.accountSearchForm}
          setStructure={navigation.editSearchStructure}
          reset={browse.reset}
          style={SEARCH_TABLE_STYLE}
        />
      ) : (
        <Skeleton variant="rectangular" height={100} animation="wave" sx={skeletonSx} />
      )}
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={cashBoxOptions}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledCashBoxes>
  );
}

export default CashBoxes;
